// Construye el remitente (depósito de origen) para etiquetas y PDFs a partir
// de los campos warehouse_* que devuelve el backend (getMovement).
// Devuelve hasta 3 líneas: nombre, dirección, teléfono. Omite las vacías.
export const warehouseRemitenteLines = (src) => {
  if (!src) return [];
  const name = src.warehouse_name || "";
  const calle = [src.warehouse_street, src.warehouse_number]
    .filter(Boolean)
    .join(" ");
  const loc = [
    src.warehouse_province,
    src.warehouse_postal_code ? `(CP ${src.warehouse_postal_code})` : "",
  ]
    .filter(Boolean)
    .join(" ");
  const dir = [calle, loc].filter(Boolean).join(", ");
  const tel = src.warehouse_phone ? `Tel: ${src.warehouse_phone}` : "";
  return [name, dir, tel].filter(Boolean);
};

// Versión de una sola línea (para la etiqueta de bulto).
export const warehouseRemitenteOneLine = (src) =>
  warehouseRemitenteLines(src).join(" — ");
